/* eslint-disable vue/one-component-per-file --
 * These are single-path SVG glyphs, not UI components; keeping them in one
 * module beats a file per icon. */
import { defineComponent, h } from 'vue'

// Custom glyphs used by the launchpad and sidebar, for shapes the
// @gohighlevel/ghl-icons set does not cover.

// Custom "AI query" glyph (matches the one previously inlined in SidePanel).
export const AiQueryIcon = defineComponent({
  name: 'AiQueryIcon',
  render() {
    return h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        class: this.$attrs.class
      },
      [
        h('polyline', { points: '7 5 2 12 7 19' }),
        h('polyline', { points: '17 5 22 12 17 19' }),
        h('path', {
          d: 'M12 7.5c0 2.2-1.8 4-4 4 2.2 0 4 1.8 4 4 0-2.2 1.8-4 4-4-2.2 0-4-1.8-4-4z',
          fill: 'currentColor',
          stroke: 'none'
        })
      ]
    )
  }
})

/** Sidebar "back to launchpad" glyph. */
export const HomeIcon = defineComponent({
  name: 'HomeIcon',
  render() {
    return h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        class: this.$attrs.class
      },
      [h('path', { d: 'M3 10.5L12 3l9 7.5' }), h('path', { d: 'M5 9.5V21h14V9.5' })]
    )
  }
})

/** Launchpad card affordance. */
export const ArrowIcon = defineComponent({
  name: 'ArrowIcon',
  render() {
    return h(
      'svg',
      {
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        class: this.$attrs.class
      },
      [h('path', { d: 'M5 12h14M13 6l6 6-6 6' })]
    )
  }
})
